import * as yup from 'yup';

const schema = yup.object().shape({
  phone_number: yup.string().required('Phone number is required'),
});

export default schema;
